module.exports = {"media":{"singular":"media","plural":"media"}}